import React, { useEffect, useMemo, useState } from "react";
import "./Uow-dashboard.css";
import { Line, Doughnut } from "react-chartjs-2";
import chartDataLabels from 'chartjs-plugin-datalabels'
import { Tabs, Tab, Table } from "react-bootstrap";
import BootstrapPagination from "../../components/BootstrapPagination";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { exportToExcel } from "../../../utils/excelExports"
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  Alert,
  Anchor,
  Modal,
  Pagination
} from "react-bootstrap";
import { Bar, Pie } from "react-chartjs-2";

import dayjs from "dayjs";

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import crest from "../../../assets/crest.png";
import warwickTextLogo from "../../../assets/warwickTextLogo.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import { getDashboardFullDetailsURL } from "../desktop-app/utils/constants";
import "./chartConfig"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Title,
  Filler,
  ChartOptions,
} from "chart.js";
 


// ---------- Types to align with backend ----------
type FeedbackValue = "Excellent" | "Good" | "Average" | "Poor";
type FilterKey =
  | "first_name"
  | "last_name"
  | "email"
  | "conversation_id"
  | "time_range"          //  ADD THIS
  | "create_incident"
  | "kb_resolved"
  | "kb_search"
  | "status_check"
  | "ticket_update"
  | "live_chat"
  | "live_call"
  | "schedule_call";

type FilterOption =
  | {
    key: Exclude<FilterKey, "time_range">;
    label: string;
    inputType: "text" | "number" | "date";
  }
  | {
    key: "time_range";
    label: string;
  };
type DrilldownType = 'DEFAULT' | 'UNIQUE_USERS' | 'REPEATED_USERS';
type DrilldownState = {
  title: string;
  rows: any[];
  type: 'DEFAULT' | 'UNIQUE_USERS' | 'REPEATED_USERS';
};
const FILTER_OPTIONS: FilterOption[] = [
  { key: "first_name", label: "First Name", inputType: "text" },
  { key: "last_name", label: "Last Name", inputType: "text" },
  { key: "email", label: "User Email", inputType: "text" },
  { key: "conversation_id", label: "Conversation ID", inputType: "text" },

  //  special case
  { key: "time_range", label: "Time Range" },

  { key: "create_incident", label: "Create Incident Count", inputType: "number" },
  { key: "kb_resolved", label: "KB Resolved Count", inputType: "number" },
  { key: "kb_search", label: "KB Search Count", inputType: "number" },
  { key: "status_check", label: "Status Check Count", inputType: "number" },
  { key: "ticket_update", label: "Ticket Update Count", inputType: "number" },
  { key: "live_chat", label: "Live Chat Count", inputType: "number" },
  { key: "live_call", label: "Live Call Count", inputType: "number" },
  { key: "schedule_call", label: "Schedule Call Count", inputType: "number" },
];
interface UserDetail {
  conversation_id: string;
  first_name?: string;
  last_name?: string;
}
interface FeedbackItem {
  feedback: FeedbackValue;
  count: number;
}
interface ChatHistoryItem {
  role: 'Bot' | 'User';
  activity?: {
    text?: string;
    [key: string]: any;
  };
  timestamp?: string;
}

interface ResolvedByBotBlock {
  total_conversations: number;
  not_resolved_conversations: number;
  dropoff_conversations: number;
  not_resolved_or_dropoff_conversations: number;
  resolved_by_bot_count: number;
  total_ids?: string[];
  not_resolved_ids?: string[];
  dropoff_ids?: string[];
  not_resolved_or_dropoff_ids?: string[];
  total_not_resolved_by_bot?: number;
  kb_resolved_count?: number;
}
export interface TicketConversationDetail {
  conversation_id: string;
  first_name: string | null;
  last_name: string | null;
}

export interface TicketCreationSummary {
  total_count: number;
  conversations: TicketConversationDetail[];
}
interface DashboardResponse {
  params: {
    db: string;
    collection: string;
    start: string;
    end: string | null;
  };
  dropoff: {
    bot_only_dropoff_count: number;
    bot_only_dropoff_details: UserDetail[];
  };

  connections: {
    live_chat_connected: number;
    live_call_connected: number;
    schedule_call_connected: number;
  };

  top_use_cases: {
    use_case: string;
    total_count: number;
    details: UserDetail[];
  }[];

  ticket_creation?: {
    direct_ticket: TicketCreationSummary;
    kb_resolved_ticket: TicketCreationSummary;
  };
  users: {
    unique_users: number;
    unique_user_details: UserDetail[];
    repeated_users_count: number;
    repeated_users_list?: {
      user_email: string;
      distinct_conversations: number;
    }[];
  };

  sessions: {
    total_sessions: number;
  };
  total_chat_conversation_count: {
    total_chat_count: number;
  };


  feedback: FeedbackItem[];
  not_resolved_by_bot: {
    fallback_only: number;
    live_agent_only: number;
    both: number;
    total_not_resolved_by_bot: number;
  };
  resolved_by_bot: ResolvedByBotBlock;
  live_agent: {
    count: number;
    conversation_ids?: string[];
  };

  conversations: {
    left_conversation_users: number;
  };


  resolved_by_bot_last_3_months: {
    month: string;
    total: number
    resolved_by_bot: number;
    not_resolved_or_dropoff: number;
    resolved_percentage: number;
  }[];

  unique_users_last_3_months: {
    month: string;
    unique_users: number;
  }[];
  user_satisfaction_last_3_months: {
    month: string;
    total: number;
    excellent_count: number;
    excellent_percentage: number;
    good_count: number;
    good_percentage: number;
  }[];

}
interface TopUseCase {
  use_case: string;
  total_count: number;
}
type BotConversationFilter =
  | "ALL"
  | "live_chat"
  | "live_call"
  | "schedule_call"
  | "dropoff";

// ---------- helpers ----------
export const formatDate = (date?: string | Date, format: string = "YYYY-MM-DD"): string =>
  dayjs(date || new Date()).format(format);

const UowDashboard: React.FC = () => {
  // API State
  useEffect(() => {
  if (!data) {
    fetchDashboard();
    fetchReportData();
  }
}, []);
 
  const ITEMS_PER_PAGE = 15;

  const [currentPage, setCurrentPage] = useState(1);

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState<ChatHistoryItem[]>([]);
  const openHistoryModal = (history: any[]) => {
    setSelectedHistory(history || []);
    setShowHistoryModal(true);
  };

  const closeHistoryModal = () => {
    setShowHistoryModal(false);
    setSelectedHistory([]);
  };
  const [botTypeFilter, setBotTypeFilter] =
    useState<BotConversationFilter>("ALL");
  const [data, setData] = useState<DashboardResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [activeTab, setActiveTab] = useState<"metrics" | "reports">("metrics");
  const [reportData, setReportData] = useState<any[]>([]);
  const [reportLoading, setReportLoading] = useState(false);
  const [val, setVal] = useState({
    startDate: formatDate(),
    endDate: formatDate(),
    getReportLoader: false,
    liveAgentCount: 0,
  });

  const [drilldown, setDrilldown] = useState<DrilldownState | null>(null);

  // const [filters, setFilters] = useState({
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  //   conversationId: "",

  //   startDate: "",
  //   endDate: "",

  //   createIncident: "",
  //   kbResolved: "",
  //   kbSearch: "",
  //   statusCheck: "",
  //   ticketUpdate: "",
  //   liveChat: "",
  //   liveCall: "",
  //   scheduleCall: "",
  // });
  type ModalFilter = {
  key: string;
  value: string;
};

const [ModalappliedFilter, setModalAppliedFilter] =
  useState<ModalFilter | null>(null);
const [ModalactiveFilter, setModalActiveFilter] =
  useState<string | null>(null);
const [ModalfilterValue, setModalFilterValue] = useState('');
const filteredRows = useMemo(() => {
  if (!drilldown?.rows) return [];

  //  use MODAL applied filter
  if (!ModalappliedFilter) return drilldown.rows;

  const { key, value } = ModalappliedFilter;

  return drilldown.rows.filter(row => {
    const cellValue =
      key === "count"
        ? row.count ?? row.distinct_conversations
        : row[key];

    return String(cellValue ?? "")
      .toLowerCase()
      .includes(String(value).toLowerCase());
  });
}, [drilldown, ModalappliedFilter]);
  useEffect(() => {
    setCurrentPage(1);
  }, [reportData]);

  


  // Charts (sample/demo)
  // const lineChartData = {
  //   labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  //   datasets: [
  //     {
  //       label: "undefined",
  //       data: [2, 3, 4, 3, 5, 4, 5, 6, 7, 1, 2, 5],
  //       borderColor: "red",
  //       pointBackgroundColor: "red",
  //       pointRadius: 3,
  //       pointHoverRadius: 2,
  //       fill: true,
  //       tension: 0.0,
  //     },
  //   ],
  // };
  const formatMonthLabel = (month: string) => {
    return `${dayjs(month, "YYYY-MM").format("MMM")} `;
  };

  const lineChartData = useMemo(() => {
    const months = data?.unique_users_last_3_months ?? [];

    return {
      labels: months.map(m =>
        formatMonthLabel(m.month)
      ),
      datasets: [
        {
          label: "Unique Users",
          data: months.map(m => m.unique_users ?? 0),
          borderColor: "#0B5FFF",
          backgroundColor: "rgba(11,95,255,0.2)",
          pointRadius: 4,
          tension: 0.3,
          fill: true,
        },
      ],
    };
  }, [data]);

const lineChartDataResolved = useMemo(() => {
  const months = data?.resolved_by_bot_last_3_months ?? [];
  return {
    labels: months.map(m => formatMonthLabel(m.month)),
    datasets: [
      {
        label: "Resolved",   // was "Resolved" — now clearly total (kb + bot) resolution
        data: months.map(m => m.resolved_percentage),
        borderColor: "#51d7c1ff",
        backgroundColor: "rgba(75, 192, 173,0.2)",
        pointRadius: 4,
        tension: 0.3,
        fill: true,
      },
    ],
  };
}, [data]);

  const lineChartDataUserSatisfaction = useMemo(() => {
    const months = data?.user_satisfaction_last_3_months ?? [];

    return {
      labels: months.map(m =>
        formatMonthLabel(m.month)
      ),
      datasets: [
        {
          label: "Excellent",
          data: months.map(m => m.excellent_percentage),
          borderColor: "#51d7c1ff",
          backgroundColor: "rgba(75, 192, 173,0.2)",
          pointRadius: 4,
          tension: 0.3,
          fill: true,
        },
        {
          label: "Good",
          data: months.map(m => m.good_percentage),
          borderColor: "#6cb7ffff",
          backgroundColor: "rgba(108, 183, 255,0.2)",
          pointRadius: 4,
          tension: 0.3,
          fill: true,
        },
      ],
    };
  }, [data]);

  const lineOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,

    layout: {
      padding: {
        top: 20, //  space for top labels
      },
    },

    scales: {
      x: {
        ticks: {
          color: "#000000",
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
      y: {
        beginAtZero: true,
        grace: "10%", //  prevents top value clipping
        ticks: {
          color: "#000000",
          font: {
            size: 14,
            weight: "bold",
          },
          precision: 0,
          callback: (value) => `${value}`
        },
      },
    },

    plugins: {
      legend: {
        labels: {
          color: "#000000",
          font: {
            size: 12,
            weight: "bold",
          },
        },
      },

      //  VALUE LABELS ON LINE POINTS
      datalabels: {
        display: (ctx: any) => {
      const value = ctx.dataset.data[ctx.dataIndex];
      return value !== null && value !== undefined && value !== 0;
    },
        align: "top",
        anchor: "end",
        color: "#000000",
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value: number) => `${value.toFixed(1)}%`, //  show actual value
      },
    },
  };
  const countLineOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
      },
    },

    scales: {
      x: {
        ticks: {
          color: "#000000",
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
      y: {
        beginAtZero: true,
        grace: "10%",
        ticks: {
          color: "#000000",
          font: {
            size: 14,
            weight: "bold",
          },
          precision: 0,
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: "#000000",
          font: {
            size: 12,
            weight: "bold",
          },
        },
      },

      datalabels: {
        align: "top",
        anchor: "end",
        color: "#000000",
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value: number) => value,
      },
    },
  };


  const percentageLineOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
      },
    },

    scales: {
      x: {
        ticks: {
          color: "#000000",
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
      y: {
        beginAtZero: true,
        grace: "10%",
        ticks: {
          callback: (value) => `${value}%`,
          color: "#000000",
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: "#000000",
          font: {
            size: 12,
            weight: "bold",
          },
        },
      },

      datalabels: {
        align: "top",
        anchor: "end",
        color: "#000000",
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value: number) => `${value}%`,
      },
    },
  };
 

  // const doughnutData = {
  //   labels: ["Create Incident", "Ticket Status Check", "Ticket update"],
  //   datasets: [{
  //     data: [2, 3, 4],
  //     backgroundColor: ["#A7D6E8", "#5875A3", "#5A9BD6"],
  //     hoverBackgroundColor: ["#A7D6E8", "#5875A3", "#4E8CC4"],
  //     borderWidth: 0,
  //   }],
  // };


  // Fetch initial
  useEffect(() => { fetchDashboard(); fetchReportData(); }, []);

  const fetchDashboard = async (params?: {
    start?: string;
    end?: string;
    listRepeated?: boolean;
    printIds?: boolean;
  }) => {
    setError(null);
    setLoading(true);
    try {
      const qs = new URLSearchParams();
      qs.set("start", params?.start || `${val.startDate}T00:00:00Z`);
      qs.set("end", params?.end || `${val.endDate}T23:59:59Z`);
      if (params?.listRepeated) qs.set("listRepeated", String(params.listRepeated));
      if (params?.printIds) qs.set("printIds", String(params.printIds));

      const result = await fetch(`${getDashboardFullDetailsURL}?${qs.toString()}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!result.ok) {
        const text = await result.text();
        throw new Error(`HTTP ${result.status}: ${text || result.statusText}`);
      }

      const json: DashboardResponse = await result.json();
      setData(json);
      setSummary(json);
      setVal(prev => ({
        ...prev,
        liveAgentCount: json?.live_agent?.count ?? 0,
        getReportLoader: false,
      }));
    } catch (err: any) {
      setError(err?.message || "Failed to load dashboard data");
      setVal(prev => ({ ...prev, getReportLoader: false }));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const today = dayjs().format("YYYY-MM-DD");
    if(dayjs(val.startDate).isAfter(dayjs(today))){
      alert("Start Date cannot be a future date");
      return;
    }
    if(dayjs(val.endDate).isAfter(dayjs(today))){
      alert("End Date cannot be a future date");
      return;
    }
    setVal(prev => ({ ...prev, getReportLoader: true }));
    fetchDashboard({
      start: `${val.startDate}T00:00:00Z`,
      end: `${val.endDate}T23:59:59Z`,
      listRepeated: false,
      printIds: false,
    });
    fetchReportData()
  };
  const getUseCaseCount = (
    data: DashboardResponse | null,
    useCase: string
  ): number => {
    return (
      data?.top_use_cases?.find(
        (u: TopUseCase) => u.use_case === useCase
      )?.total_count ?? 0
    );
  };
  const handleDateChange: React.ChangeEventHandler<HTMLInputElement> = (event) =>
    setVal(prev => ({ ...prev, [event.target.name]: event.target.value }));

  const [activeFilter, setActiveFilter] = useState<FilterKey | null>(null);

  const [filterValue, setFilterValue] = useState("");
  type FilterValue =
    | string
    | {
      from: string;
      to: string;
    };

  const [appliedFilter, setAppliedFilter] = useState<{
    key: FilterKey;
    value: FilterValue;
  } | null>(null);
  const [timeFrom, setTimeFrom] = useState("");
  const [timeTo, setTimeTo] = useState("");

  const [summary, setSummary] = useState<DashboardResponse | null>(null);

  type MetricKey =
    | 'TOP_USE_CASES'
    | 'BOT_CONVERSATION'
    | 'UNIQUE_USERS'
    | 'LIVE_CHAT'
    | 'LIVE_CALL'
    | 'SCHEDULE_CALL'
    | 'USER_SATISFACTION'
    | 'TICKET_BREAKDOWN'
    | 'RESOLVE_STATUS';
  const handleChartClick = (
    metric: MetricKey,
    elements: any[],
    chartData?: any
  ) => {
    if (!elements.length || !chartData) return;
    const dashboardData = data;
    if (!dashboardData) return;

    const index = elements[0].index;
    const label = chartData.labels[index];

    let title = '';
    let rows: any[] = [];

    console.log('Clicked:', metric, 'Label:', label);

    switch (metric) {
      case 'TOP_USE_CASES': {
        title = `Use Case: ${label}`;

        rows = getRowsForUseCase(label);
        setDrilldown({
          title,
          type: 'DEFAULT',
          rows,
        });

        break;
      }

      case 'BOT_CONVERSATION': {
        title = `Use Case: ${label}`;
        rows = getRowsForUseCase(label);
        setDrilldown({
          title,
          type: 'DEFAULT',
          rows,
        });

        break;
      }

      case 'TICKET_BREAKDOWN': {
        title = `${label}`;
        rows = getRowsForUseCase(label);
        setDrilldown({
          title,
          type: 'DEFAULT',
          rows,
        });

        break;
      }

      case 'UNIQUE_USERS':
        setDrilldown({
          title: 'Unique Users',
          type: 'UNIQUE_USERS',
          rows: data.users.unique_user_details || [],
        });
        return;


      case 'LIVE_CHAT':
        title = 'Live Chat';
        rows = reportData
          .filter(r => r.live_chat > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.live_chat,
          }));
        setDrilldown({
          title,
          type: 'DEFAULT',
          rows,
        });

        break;

      case 'RESOLVE_STATUS':
        title = label;
        rows = getRowsForUseCase(label)
        setDrilldown({
          title,
          type: 'DEFAULT',
          rows,
        });

        break;

      case 'USER_SATISFACTION':
        title = label;
        rows = getRowsForUseCase(label)
        setDrilldown({
          title,
          type: 'DEFAULT',
          rows,
        });

        break;
      default:
        return;
    }

    setDrilldown({
      title,
      type: 'DEFAULT',
      rows,
    });

  };
  useEffect(() => {
  if (!drilldown) {
    setModalActiveFilter(null);
    setModalFilterValue("");
    setModalAppliedFilter(null);
  }
}, [drilldown]);
const hasSelectedFilter = !!ModalactiveFilter;
const hasAppliedFilter = !!ModalappliedFilter;

  const getRowsForUseCase = (useCase: string) => {
    switch (useCase) {

      case 'KB Resolved':
        return reportData
          .filter(r => r.kb_resolved_incident > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.kb_resolved_incident,
          }));

      case 'Direct Ticket Creation':

        return reportData
          .filter(r => r.direct_incident > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.direct_incident,
          }));

      case 'KB Resolved Ticket Creation':
        return reportData
          .filter(r => r.kb_resolved_incident > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.kb_resolved_incident,
          }));
      case 'FAQ KB Search':

        return reportData
          .filter(r => r.kb_search > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.kb_search,
          }));

      case 'Drop-offs':

        return reportData
          .filter(r => (r.drop_off > 0))
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.drop_off,
          }));

      case 'Ticket Created':
        return reportData
          .filter(r => r.ticket_created > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.ticket_created,
          }));
      case 'Ticket Status Check':
        return reportData
          .filter(r => r.ticket_status_check > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.ticket_status_check,
          }));
      case 'Live Chat':
        return reportData
          .filter(r => r.live_chat > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.live_chat,
          }));

      case 'Live Call':
        return reportData
          .filter(r => r.live_call > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.live_call,
          }));

      case 'Schedule Call':
        return reportData
          .filter(r => r.schedule_call_back > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.schedule_call_back,
          }));

      case 'Resolved':
        // Resolved now reflects KB Resolved Ticket Creation, not the old bot-resolved logic.
        return reportData
          .filter(r => r.kb_resolved_incident > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.kb_resolved_incident,
          }));

      case 'Partially Resolved':
        // Partially Resolved now uses the previous "resolved by bot" logic
        // (bot handled it with no fallback and no live-agent escalation).
        return reportData
          .filter(r => r.resolved_by_bot_count > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.resolved_by_bot_count,
          }));

      case 'Ticket Update':
          return reportData
          .filter(r => r.ticket_update > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.ticket_update,
          }));

      case 'Not Resolved':
        return reportData
          .filter(r => r.total_not_resolved_by_bot > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.total_not_resolved_by_bot,
          }));


      case 'Excellent':
        return reportData
          .filter(r => r.feedback.Excellent > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.feedback.Excellent,
          }));


      case 'Good':
        return reportData
          .filter(r => r.feedback.Good > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.feedback.Good,
          }));


      case 'Average':
        return reportData
          .filter(r => r.feedback.Average > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.feedback.Average,
          }));


      case 'Poor':
        return reportData
          .filter(r => r.feedback.Poor > 0)
          .map(r => ({
            conversation_id: r.conversation_id,
            first_name: r.first_name,
            last_name: r.last_name,
            count: r.feedback.Poor,
          }));
      default:
        return [];
    }
  };

  const showClear =
  !!ModalappliedFilter ||
  (!!ModalactiveFilter && !!ModalfilterValue);
console.log("show clear::",showClear)
  const renderUsecaseModal = () => (
    <Modal
      show={!!drilldown}
      onHide={() => setDrilldown(null)}
      size="lg"
      centered
      scrollable
    >
      <Modal.Header
        style={{
          background: '#693594',
          color: '#ffffff',
        }}
        closeButton
      >
        <Modal.Title>{drilldown?.title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!drilldown || drilldown.rows.length === 0 ? (
          <div className="text-muted">No data available</div>
        ) : (<>
      <Row className="mb-3 align-items-end">

  {/*  Filter dropdown – always visible */}
<Col style={{ maxWidth: 220, flex: "0 0 220px" }}>
    <Form.Select
      size="sm"
      value={ModalactiveFilter ?? ""}
      onChange={e => {
        setModalActiveFilter(e.target.value || null);
        setModalFilterValue("");
        setModalAppliedFilter(null);
      }}
    >
      <option value="">Select Filter</option>
      <option value="first_name">First Name</option>
      <option value="last_name">Last Name</option>

      {drilldown?.type === "DEFAULT" && (
        <option value="conversation_id">Conversation ID</option>
      )}

      {(drilldown?.type === "DEFAULT" ||
        drilldown?.type === "REPEATED_USERS") && (
        <option value="count">Count</option>
      )}
    </Form.Select>
  </Col>

  {/*  Input appears AFTER selecting filter */}
  {hasSelectedFilter && (
    <Col md={4}>
      <Form.Control
        size="sm"
        placeholder={`Enter ${ModalactiveFilter?.replace('_', ' ')}`}
        value={ModalfilterValue}
        onChange={e => setModalFilterValue(e.target.value)}
      />
    </Col>
  )}

  {/*  Search + Clear */}
  <Col xs="auto" className="d-flex gap-2">

    {/*  Search */}
    {hasSelectedFilter && (
      <Button
        size="sm"
        variant="primary"
        disabled={!ModalfilterValue}
        onClick={() => {
          setModalAppliedFilter({
            key: ModalactiveFilter!,
            value: ModalfilterValue
          });
          setCurrentPage(1);
        }}
      >
        Search
      </Button>
    )}

    {/*  Clear appears ONLY after search */}
    {hasAppliedFilter && (
      <Button
        size="sm"
        variant="outline-secondary"
        onClick={() => {
          setModalFilterValue("");
          setModalAppliedFilter(null);
          setCurrentPage(1);
        }}
      >
        Clear
      </Button>
    )}

  </Col>
</Row>
 <Table bordered hover size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>First Name</th>
                <th>Last Name</th>


                {(drilldown.type === 'UNIQUE_USERS' ||
                  drilldown.type === 'REPEATED_USERS') && (
                    <th>Email ID</th>
                  )}


                {drilldown.type === 'DEFAULT' && (
                  <th>Conversation ID</th>
                )}


                {(drilldown.type === 'DEFAULT' ||
                  drilldown.type === 'REPEATED_USERS') && (
                    <th>Count</th>
                  )}
              </tr>
            </thead>

            <tbody>{filteredRows.length === 0 && (
  <tr>
    <td
      colSpan={
        3 +
        (drilldown.type === "DEFAULT" ? 1 : 0) +
        (drilldown.type !== "UNIQUE_USERS" ? 1 : 0) +
        (drilldown.type !== "DEFAULT" ? 1 : 0)
      }
      className="text-center text-muted"
    >
      No matching records
    </td>
  </tr>
)}
              {filteredRows.map((row, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{row.first_name ?? '-'}</td>
                  <td>{row.last_name ?? '-'}</td>

                  {(drilldown.type === 'UNIQUE_USERS' ||
                    drilldown.type === 'REPEATED_USERS') && (
                      <td>{row.user_email ?? '-'}</td>
                    )}

                  {drilldown.type === 'DEFAULT' && (
                    <td>{row.conversation_id}</td>
                  )}

                  {(drilldown.type === 'DEFAULT' ||
                    drilldown.type === 'REPEATED_USERS') && (
                      <td>{row.count ?? row.distinct_conversations}</td>
                    )}
                </tr>
              ))}
             
            </tbody>
            
          </Table>
</>
         
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-end">
        <Button
          type="button"
          size="sm"
          className={`get-report-btn ${val.getReportLoader}`}
          variant="light"
          onClick={() => exportDrilldownExcel(drilldown)}
        >
          Download
        </Button>
      </Modal.Footer>

    </Modal>
  );

  const exportDrilldownExcel = (drilldown: DrilldownState | null) => {
    if (!drilldown || !drilldown.rows?.length) return;

    let excelRows: any[];

    switch (drilldown.type) {
      case "UNIQUE_USERS":
        excelRows = drilldown.rows.map((row, idx) => ({
          "S.No": idx + 1,
          "First Name": row.first_name ?? "-",
          "Last Name": row.last_name ?? "-",
          "Email ID": row.user_email ?? "-",
        }));
        break;

      case "REPEATED_USERS":
        excelRows = drilldown.rows.map((row, idx) => ({
          "S.No": idx + 1,
          "First Name": row.first_name ?? "-",
          "Last Name": row.last_name ?? "-",
          "Email ID": row.user_email ?? "-",
          "Count": row.distinct_conversations ?? row.count ?? 0,
        }));
        break;

      case "DEFAULT":
      default:
        excelRows = drilldown.rows.map((row, idx) => ({
          "S.No": idx + 1,
          "First Name": row.first_name ?? "-",
          "Last Name": row.last_name ?? "-",
          ...(row.conversation_id && {
            "Conversation ID": row.conversation_id,
          }),
          ...(row.count !== undefined && {
            "Count": row.count,
          }),
        }));
    }

    exportToExcel(excelRows, {
      fileName: `${drilldown.title.replace(/\s+/g, "_")}_${val.startDate}_to_${val.endDate}`,
      sheetName: drilldown.title,
    });
  };

  // ----------- Derived data -----------
  const totalSessions = data?.resolved_by_bot?.total_conversations ?? 0;
  const liveChatConnected =
    data?.connections?.live_chat_connected ?? 0;

  const liveCallConnected =
    data?.connections?.live_call_connected ?? 0;

  const scheduleCallConnected =
    data?.connections?.schedule_call_connected ?? 0;
  const dropoffConversations = data?.dropoff?.bot_only_dropoff_count ?? 0;
  // partiallyResolvedCount now correctly excludes KB-resolved conversations
  // (comes straight from the corrected backend field, no change needed here)
  const partiallyResolvedCount = data?.resolved_by_bot?.resolved_by_bot_count ?? 0;
  const notResolvedCount = data?.resolved_by_bot?.total_not_resolved_by_bot ?? 0;
  const uniqueUsers = data?.users?.unique_users ?? 0;
  const repeatedUsers = data?.users?.repeated_users_count ?? 0;
  // const directTicketCount =
  //   data?.ticket_creation?.direct_ticket?.total_count;

  // const directTicketConversations =
  //   data?.ticket_creation?.direct_ticket?.conversations;

  // const kbResolvedCount =
  //   data?.ticket_creation?.kb_resolved_ticket?.total_count;


  const total_incident = getUseCaseCount(data, "Ticket Created");

  const kb_resolved_incident = getUseCaseCount(data, "KB Resolved Incident")
  // const kb_resolved_count = data?.resolved_by_bot?.kb_resolved_count ??0;
  // "Resolved" pie slice = count of KB Resolved Ticket Creation
  const resolvedCount = data?.resolved_by_bot?.kb_resolved_count ?? 0;
  // const direct_incident = total_incident - liveCallConnected - liveChatConnected - scheduleCallConnected;
  const directIncidentBreakdown = reportData
    .filter(r => r.direct_incident > 0)
    .map(r => ({
      conversation_id: r.conversation_id,
      first_name: r.first_name,
      last_name: r.last_name,
      count: r.direct_incident,
    }));
  const direct_incident = directIncidentBreakdown.reduce(
    (sum, item) => sum + item.count,
    0
  );

  const feedbackMap = useMemo(() => {
    const base = { Excellent: 0, Good: 0, Average: 0, Poor: 0 } as Record<FeedbackValue, number>;
    (data?.feedback || []).forEach(f => { if (f.feedback in base) base[f.feedback as FeedbackValue] = f.count; });
    return base;
  }, [data]);

  // Charts
  const barDataLastUseCase = {
    labels: [`Live Chat`, `Live Call`, `Schedule Call`, `Drop-offs`],
    datasets: [{
      label: "Count",
      data: [liveChatConnected, liveCallConnected, scheduleCallConnected, dropoffConversations],
      backgroundColor: ["#3e0974ff", "#62388fff", "#896aabff", "#af9bc5ff"],
      borderColor: ["#3e0974ff", "#62388fff", "#896aabff", "#af9bc5ff"],
      borderWidth: 0,
      borderRadius: 6,
      maxBarThickness: 48,
      hoverBackgroundColor: ["#3e0974ff", "#62388fff", "#896aabff", "#af9bc5ff"],
      hoverBorderColor: ["#3e0974ff", "#62388fff", "#896aabff", "#af9bc5ff"],
    }],
  };

  const pieDataResolved = {
    labels: [`Resolved`, `Partially Resolved`, `Not Resolved`],
    datasets: [{
      data: [resolvedCount, partiallyResolvedCount, notResolvedCount],
      backgroundColor: ["#51d7c1ff", "#f6c667ff", "#f1977fff"],
      borderColor: "#ffffff",
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };
  const pieDataIncident = {
    labels: [`Direct Ticket Creation`, `KB Resolved Ticket Creation`],
    datasets: [{
      data: [direct_incident, kb_resolved_incident],
      backgroundColor: ["#a499f4ff", "#6cb7ffff"],
      borderColor: "#ffffff",
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };

  const barDataUserSatisfaction = {
    labels: ["User Satisfaction"],
    datasets: [
      { label: `Excellent`, data: [feedbackMap.Excellent], backgroundColor: "#28A745" },
      { label: `Good`, data: [feedbackMap.Good], backgroundColor: "rgb(71, 255, 34)" },
      { label: `Average`, data: [feedbackMap.Average], backgroundColor: "#FD7E14" },
      { label: `Poor`, data: [feedbackMap.Poor], backgroundColor: "#DC3545" },
    ],
  };


  const barCommonOptions: ChartOptions<"bar"> = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30,
      },
    },
    onHover: (event: any, elements: any[], chart: any) => {
      chart.canvas.style.cursor = elements.length ? "pointer" : "default";
    },
    plugins: {
      datalabels: {
          display: (ctx: any) => {
              const value = ctx.dataset.data[ctx.dataIndex];
              return value !== null && value !== undefined && value !== 0;
            },
        anchor: 'end',
        align: 'top',
        color: '#000',
        font: {
          weight: 'bold',
          size: 12
        },

      },
      legend: { display: false },
      tooltip: {
        titleColor: "#000000",
        bodyColor: "#2c3e50",
        backgroundColor: "#ffffff",
        borderColor: "#bdc3c7",
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        type: "category",
        ticks: {
          color: "#000000",
          font: { size: 14, weight: "bold" },
        },
        grid: { color: "rgba(0,0,0,0.06)" },
        border: { color: "#bdc3c7", width: 1 },
      },
      y: {
        type: "linear",
        beginAtZero: true,

        ticks: {
          color: "#000000",
          font: { size: 14, weight: "bold" },


          precision: 0,      // removes decimals
          stepSize: 1,       // increments of 1
        },
        grid: { color: "rgba(0,0,0,0.06)" },
        border: { color: "#bdc3c7", width: 1 },
      },
    },
  };

  const barWithLegendOptions: ChartOptions<"bar"> = {
    ...barCommonOptions,



    plugins: {
      ...barCommonOptions.plugins,
      legend: {
        display: false,
        position: "bottom",
        labels: { color: "rgb(2, 2, 2)", font: { size: 14, weight: 600 }, usePointStyle: true, padding: 16 },
      },
    },
  };
  //  const gaugeOptions: ChartOptions<"doughnut"> = {
  //     cutout: "50%",
  //     rotation: -90,
  //     aspectRatio: 1,

  //     plugins: {
  //       legend: {
  //         display: true,
  //         position: "bottom",
  //         labels: {
  //           color: "#000000",
  //           font: {
  //             size: 14,
  //             weight: "bold", 
  //           },
  //           usePointStyle: true,
  //         },
  //       },
  //        datalabels: {
  //       color: "#000000",
  //       font: {
  //         weight: "bold",
  //         size: 14,
  //       },
  //          formatter: (value: any) => {
//   if (value === null || value === undefined || isNaN(value)) return "";
//   return value;
// }
 
  //     },
  //       tooltip: {
  //         enabled: true,
  //       },
  //       title: {
  //         display: false,
  //       },
  //     },
  //   };
  const gaugeOptions: ChartOptions<"doughnut"> = {
    cutout: "50%",
    rotation: -90,
    aspectRatio: 1,
    onHover: (event: any, elements: any[], chart: any) => {
      chart.canvas.style.cursor = elements.length ? "pointer" : "default";
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#000",
          font: { size: 14, weight: "bold" },
          usePointStyle: true,
        },
      },

      datalabels: {
        display: (ctx: any) => {
      const value = ctx.dataset.data[ctx.dataIndex];
      return value !== null && value !== undefined && value !== 0;
    },
        color: "#000000",
        font: {
          weight: "bold",
          size: 14,
        },
           formatter: (value: any) => {
  if (value === null || value === undefined || isNaN(value)) return "";
  return value;
}
 
      },

      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${ctx.raw}`,
        },
      },
    },
  };
  const pieOptions: ChartOptions<'pie'> = {
    maintainAspectRatio: false,

    interaction: {
      mode: 'nearest',
      intersect: true,
    },

    onHover: (_, elements, chart) => {
      chart.canvas.style.cursor = elements.length ? 'pointer' : 'default';
    },

    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#000',
          font: { size: 14, weight: 'bold' },
          usePointStyle: true,
        },
      },

      datalabels: {
        display: (ctx: any) => {
      const value = ctx.dataset.data[ctx.dataIndex];
      return value !== null && value !== undefined && value !== 0;
    },
        color: '#000',
        font: {
          weight: 'bold',
          size: 14,
        },
           formatter: (value: any) => {
  if (value === null || value === undefined || isNaN(value)) return "";
  return value;
}
 ,
      },

      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: ${ctx.raw}`,
        },
      },
    },
  };
  // ---------- Cards ----------
  const StatCard = ({
    iconClass,
    label,
    value,
  }: {
    iconClass: string;
    label: string;
    value: number | string;
  }) => (
    <Card className="stat-card" style={{ padding: "0" }}>
      <div className="stat-card-header">
        <i className={iconClass} aria-hidden="true" />
        <span>{label}</span>
      </div>
      <div className="stat-card-value">{value}</div>
    </Card>
  );

  type StatColor = "blue" | "orange" | "purple" | string;
  const StatTile: React.FC<{
    color?: StatColor;
    title: string;
    value: number | string;
    iconClass?: string;
    className?: string;
    onClick?: () => void;
  }> = ({
    color = "blue",
    title,
    value,
    iconClass,
    className,
    onClick,
  }) => (
      <div
        className={`stat-card stat-${color} ${className ?? ""}`.trim()}
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
        role={onClick ? "button" : undefined}
      >
        <div className="stat-card-header">
          {iconClass ? <i className={`${iconClass} me-2`} /> : null}
          <span className="stat-title">{title}</span>
        </div>

        <div className="stat-body">
          <span className="stat-card-value">{value ?? 0}</span>
        </div>
      </div>
    );

  const BOT_AVATAR = "https://cva-dev.warwick.ac.uk/ui/warwickBotlogo_final.png"
  const USER_AVATAR = `https://cva-dev.warwick.ac.uk/ui/User_Profile_Opt1_final.png`
  const fetchReportData = async () => {
    setCurrentPage(1);
    setReportLoading(true);
    setReportData([]);

    try {
      const qs = new URLSearchParams();
      qs.set("start", `${val.startDate}T00:00:00Z`);
      qs.set("end", `${val.endDate}T23:59:59Z`);

      let url = "";


      url = `/api/v2.0/Dashboard/users/conversations/usecases`;
      if (botTypeFilter !== "ALL") {
        qs.set("type", botTypeFilter);
      }




      const res = await fetch(`${url}?${qs.toString()}`);
      const json = await res.json();
      setReportData(json?.data);

    } catch (err) {
      console.error(err);
    } finally {
      setReportLoading(false);
    }
  };
  const HistoryChat: React.FC<{ history: ChatHistoryItem[] }> = ({ history }) => {
    return (
      <div className="chat-history">
        {history.length === 0 ? (
          <div className="empty-state">No conversation data available</div>
        ) : (
          history.map((item) => (
            <div
              key={item.activity?.id}
              className={`chat-row ${item.role === 'Bot' ? 'bot' : 'user'}`}
            >
              <div
                className="avatar"
                style={{
                  backgroundImage: `url(${item.role === 'Bot' ? BOT_AVATAR : USER_AVATAR
                    })`,
                }}
              />
              <div className="bubble">
                <div className="message-text">
                  {item.activity?.text ?? '[Non-text activity]'}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    );
  };

  const renderHistoryModal = () => (
    <Modal
      show={showHistoryModal}
      onHide={closeHistoryModal}
      size="lg"
      centered
    >
      <Modal.Header style={{
        maxHeight: '70vh',
        overflowY: 'auto',
        background: '#693594',
        color: '#ffffff'
      }} closeButton>
        <Modal.Title>Chat Conversation</Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          maxHeight: '70vh',
          overflowY: 'auto',
          background: '#f9fafc'
        }}
      >
        <HistoryChat history={selectedHistory} />
      </Modal.Body>


    </Modal>
  );
  const getPaginationPages = (
    currentPage: number,
    totalPages: number,
    delta = 2
  ) => {
    const pages: (number | string)[] = [];
    const range = [];

    const start = Math.max(2, currentPage - delta);
    const end = Math.min(totalPages - 1, currentPage + delta);

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    if (start > 2) {
      pages.push('...');
    }

    pages.push(...range);

    if (end < totalPages - 1) {
      pages.push('...');
    }

    return [1, ...pages, totalPages].filter(
      (v, i, a) => a.indexOf(v) === i
    );
  };

  const renderReportTable = () => {

    if (reportLoading) {
      return <div className="text-center">Loading...</div>;
    }

    if (!reportData.length) {
      return <div className="text-muted">No data to display</div>;
    }

    const totalPages = Math.ceil(reportData.length / ITEMS_PER_PAGE);


    return (
      <>

        <div className="table-scroll-x">
          <Table
            bordered
            hover
            size="sm"
            className="report-table mt-3"
          >


            <thead >
              <tr>
                <th>S.No</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>User Email</th>
                <th >Conversation ID</th>
                <th>Start Time</th>
                <th>End Time</th>

                <th>Create Incident</th>
                <th>KB Resolved</th>
                <th>KB Search</th>
                <th>Status Check</th>
                <th>Ticket Update</th>
                <th>Live Chat</th>
                <th>Live Call</th>
                <th>Schedule Call</th>

                <th>Chat Transcript</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={row.conversation_id}>
                  <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>

                  <td>{row.first_name ?? "-"}</td>
                  <td>{row.last_name ?? "-"}</td>
                  <td >{row.email ?? '-'}</td>
                  <td >{row.conversation_id}</td>


                  <td>
                    {row.session_start_time
                      ? dayjs(row.session_start_time).format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </td>

                  <td>
                    {row.session_end_time
                      ? dayjs(row.session_end_time).format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </td>

                  <td>{row.create_incident_open ?? 0}</td>
                  <td>{row.kb_resolved_incident ?? 0}</td>
                  <td>{row.kb_search ?? 0}</td>
                  <td>{row.ticket_status_check ?? 0}</td>
                  <td>{row.ticket_update ?? 0}</td>
                  <td>{row.live_chat ?? 0}</td>
                  <td>{row.live_call ?? 0}</td>
                  <td>{row.schedule_call_back ?? 0}</td>

                 <td className="text-center">
  <i
    className="bi bi-eye"
    style={{ cursor: "pointer" }}
    onClick={() => openHistoryModal(row.history)}
  ></i>
</td>

                </tr>
              ))}
            </tbody>
          </Table>

        </div>
        {totalPages !== 1 && (
          <div className="text-muted text-center mt-2">
            Showing{" "}
            {(currentPage - 1) * ITEMS_PER_PAGE + 1}
            {" "}to{" "}
            {Math.min(
              currentPage * ITEMS_PER_PAGE,
              filteredData.length
            )}
            {" "}of{" "}
            {filteredData.length}
          </div>
        )}

        <Pagination size="sm" className="justify-content-center mt-3">
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
          />

          {paginationPages.map((page, idx) =>
            page === '...' ? (
              <Pagination.Ellipsis key={`ellipsis-${idx}`} disabled />
            ) : (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => setCurrentPage(page as number)}
              >
                {page}
              </Pagination.Item>
            )
          )}

          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
          />
        </Pagination>
        {renderHistoryModal()}
      </>
    );
  };

  const renderReportsTab = () => (
    <Card className="mt-2">
      <Card.Body>
        <Row className="align-items-end g-1 mt-3">
          <Col xs="auto">
            <Form.Label>Filter By</Form.Label>
            <Form.Select
              size="sm"
              value={activeFilter ?? ""}
              onChange={(e) =>
                setActiveFilter(
                  e.target.value ? (e.target.value as FilterKey) : null
                )
              }
            >
              <option value="">Select Filter</option>
              {FILTER_OPTIONS.map((opt) => (
                <option key={opt.key} value={opt.key}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
          </Col>

          {/* Normal value input */}
          {activeFilter && activeFilter !== "time_range" && (
            <Col xs="auto">
              <Form.Label>Value</Form.Label>
              <Form.Control
                size="sm"
                type={
                  FILTER_OPTIONS.find(
                    (o): o is Extract<FilterOption, { inputType: any }> =>
                      o.key === activeFilter && "inputType" in o
                  )?.inputType ?? "text"
                }
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
                placeholder="Enter value"
              />
            </Col>
          )}

          {/* Time range inputs */}
          {activeFilter === "time_range" && (
            <>
              <Col xs="auto">
                <Form.Label>From</Form.Label>
                <Form.Control
                  size="sm"
                  type="datetime-local"
                  value={timeFrom}
                  onChange={(e) => setTimeFrom(e.target.value)}
                />
              </Col>

              <Col xs="auto">
                <Form.Label>To</Form.Label>
                <Form.Control
                  size="sm"
                  type="datetime-local"
                  value={timeTo}
                  onChange={(e) => setTimeTo(e.target.value)}
                />
              </Col>
            </>
          )}

          {/* Search button */}
          <Col xs="auto">
            <Button
              size="sm"
              variant="primary"
              disabled={
                !activeFilter ||
                (activeFilter === "time_range" && (!timeFrom || !timeTo)) ||
                (activeFilter !== "time_range" && !filterValue)
              }
              onClick={() => {
                if (!activeFilter) return;

                if (activeFilter === "time_range") {
                  setAppliedFilter({
                    key: activeFilter,
                    value: { from: timeFrom, to: timeTo },
                  });
                } else {
                  setAppliedFilter({
                    key: activeFilter,
                    value: filterValue,
                  });
                }

                setCurrentPage(1);
              }}
            >
              Search
            </Button>
          </Col>

          {/* Clear button */}
          {appliedFilter && (
            <Col xs="auto">
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={() => {
                  setAppliedFilter(null);
                  setActiveFilter(null);
                  setFilterValue("");
                  setCurrentPage(1);
                }}
              >
                Clear
              </Button>
            </Col>
          )}
        </Row>


        {renderReportTable()}

      </Card.Body>
        <Modal.Footer className="justify-content-end">
        <Button
          type="button"
          size="lg"
          className={`get-report-btn ${val.getReportLoader}`}
          variant="light"
           onClick={() => exportConversationToExcel(reportData)}
        >
          Download Report
        </Button>
      </Modal.Footer>
   
    </Card>
  );

  const SAFE_LIMIT = 30000; // buffer to avoid edge issues
 
const splitTextIntoChunks = (text: string, size = SAFE_LIMIT) => {
  const chunks = [];
  for (let i = 0; i < text.length; i += size) {
    chunks.push(text.substring(i, i + size));
  }
  return chunks;
};


  const exportConversationToExcel = (rows: any[]) => {
    if (!rows || rows.length === 0) return;

     // 🔹 Flatten data for Excel
   const excelRows = rows.map((row) => {
  const fullHistory = row.history
    ?.map((h: any) => `${h.role}: ${h.activity?.text ?? "[No text]"}`)
    .join("\n") || "";
 
  const historyChunks = splitTextIntoChunks(fullHistory);
 
  // dynamically create columns
  const historyColumns: any = {};
  historyChunks.forEach((chunk, index) => {
    historyColumns[`History_${index + 1}`] = chunk;
  });
 
  return {
    ConversationID: row.conversation_id,
    Email: row.email,
    FirstName: row.first_name,
    LastName: row.last_name,
 
    StartTime: row.session_start_time,
    EndTime: row.session_end_time,
 
    CreateIncident: row.create_incident_open,
    KBResolved: row.kb_resolved_incident,
    KBSearch: row.kb_search,
    TicketStatus: row.ticket_status_check,
    TicketUpdate: row.ticket_update,
 
    LiveChat: row.live_chat,
    LiveCall: row.live_call,
    ScheduleCallback: row.schedule_call_back,
 
    DirectIncident: row.direct_incident,
    DropOff: row.drop_off,
    ResolvedByBot: row.resolved_by_bot_count,
    NotResolvedByBot: row.total_not_resolved_by_bot,
 
    Feedback_Excellent: row.feedback?.Excellent ?? 0,
    Feedback_Good: row.feedback?.Good ?? 0,
    Feedback_Average: row.feedback?.Average ?? 0,
    Feedback_Poor: row.feedback?.Poor ?? 0,
 
    ...historyColumns, //  Inject split history columns
  };
});
 

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelRows);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "User Conversations");

    // Write & download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(file, `conversation_report_${val.startDate}_to_${val.endDate}.xlsx`);
  };
  const filteredData = useMemo<any[]>(() => {
    if (!appliedFilter) return reportData;

    const { key, value } = appliedFilter;

    return reportData.filter((row) => {
      switch (key) {
        case "first_name":
          return row.first_name?.toLowerCase().includes(String(value).toLowerCase());

        case "last_name":
          return row.last_name?.toLowerCase().includes(String(value).toLowerCase());

        case "email":
          return row.email?.toLowerCase().includes(String(value).toLowerCase());

        case "conversation_id":
          return row.conversation_id?.toLowerCase().includes(String(value).toLowerCase());

        //  TIME RANGE FILTER
        case "time_range": {
          const { from, to } = value as { from: string; to: string };

          const rowStart = dayjs(row.session_start_time).valueOf();
          const rowEnd = dayjs(row.session_end_time).valueOf();

          const fromTime = dayjs(from).valueOf();
          const toTime = dayjs(to).valueOf();

          return rowStart >= fromTime && rowEnd <= toTime;
        }

        case "create_incident":
          return row.create_incident_open >= Number(value);

        case "kb_resolved":
          return row.kb_resolved_incident >= Number(value);

        case "kb_search":
          return row.kb_search >= Number(value);

        case "status_check":
          return row.ticket_status_check >= Number(value);

        case "ticket_update":
          return row.ticket_update >= Number(value);

        case "live_chat":
          return row.live_chat >= Number(value);

        case "live_call":
          return row.live_call >= Number(value);

        case "schedule_call":
          return row.schedule_call_back >= Number(value);

        default:
          return true;
      }
    });
  }, [reportData, appliedFilter]);
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredData.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  }, [filteredData, currentPage]);
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const pages = getPaginationPages(currentPage, totalPages);
  const paginationPages = useMemo(
    () => getPaginationPages(currentPage, totalPages),
    [currentPage, totalPages]
  );
  const top3 = data?.top_use_cases?.slice(0, 3) ?? [];
  // ---- NEW: Top 3 Usecases as a Bar chart (replaces old doughnut section)
  const barDataTop3Usecases = useMemo(() => {

    return {
      labels: top3.map(u => `${u.use_case}`),
      datasets: [
        {
          label: "Usecases",
          data: top3.map(u => u.total_count),
          backgroundColor: ["#6cb7ffff", "#89c6ffff", "#a7d4ffff"],
          borderRadius: 6,
          maxBarThickness: 48,
        },
      ],
    };
  }, [data]);
  // ---- NEW: User Satisfaction as a Doughnut (instead of Bar)
  const doughnutDataUserSatisfaction = {
    labels: [
      `Excellent`,
      `Good`,
      `Average`,
      `Poor`,
    ],
    datasets: [
      {
        data: [
          feedbackMap.Excellent,
          feedbackMap.Good,
          feedbackMap.Average,
          feedbackMap.Poor,
        ],
        backgroundColor: ["#51d7c1ff", "#6cb7ffff", "#fede7bff", "#f1977fff"],
        borderWidth: 2,
        borderColor: "#ffffff",
        hoverOffset: 6,
      },
    ],
  };



  return (
    <div className="uow-app light">
      <Container fluid className="px-0">
        {/* Top gradient bar */}
        <div className="topbar">
          <div className="topbar-inner">
            <div className="left">
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={crest} alt="crest" className="brand crest" />
                <img src={warwickTextLogo} alt="warwickTextLogo" className="brand logo" />
              </div>
            </div>
            <div className="topbar-title">Itika Dashboard</div>
            <div className="right" />
          </div>
        </div>

        <div className="Content">
          {/* ===================== TOP ACTION BAR (aligned to grid) ===================== */}
          <Container fluid className="uva-topbar-wrapper px-4">
            {/* align-items-stretch makes both columns the same height */}
            <Row className="gx-3 gy-2 align-items-stretch">

              {/* LEFT: Filters */}
              <Col xs={12} lg="auto">
                <Form onSubmit={handleSubmit} className="uva-filters-inline h-100">
                  <div className="uva-date-inline">
                    <Form.Label className="mb-0 small text-muted">
                      Start Date:
                    </Form.Label>
                    <Form.Control
                      name="startDate"
                      type="date"
                      value={val.startDate}
                      onChange={handleDateChange}
                      className="uva-date"
                      max={dayjs().format("YYYY-MM-DD")}
                    />
                  </div>

                  <div className="uva-date-inline">
                    <Form.Label className="mb-0 small text-muted">
                      End Date:
                    </Form.Label>
                    <Form.Control
                      name="endDate"
                      type="date"
                      value={val.endDate}
                      onChange={handleDateChange}
                      className="uva-date"
                      min={val.startDate}
                      max={dayjs().format("YYYY-MM-DD")}
                    />
                  </div>

                  <Button
                    type="submit"
                    disabled={val.getReportLoader || loading}
                    size="sm"
                    className={`get-report-btn ${val.getReportLoader || loading ? "loading-btn" : ""}`}
                    variant="light"
                  >
                    {(val.getReportLoader || loading) && (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        aria-hidden="true"
                      />
                    )}
                    GET REPORT
                  </Button>
                </Form>
              </Col>

              {/* RIGHT: Tiles */}
              <Col xs={12} lg className="d-flex">
                {/* h-100 ensures the wrapper is as tall as the left column */}
                <div className="uva-stats d-flex gap-3 ms-lg-auto w-100 justify-content-lg-end h-100">
                  <StatTile
                    color="blue"
                    title="Total Interactions With Bot"
                    value={loading ? "Loading..." : totalSessions}
                    iconClass="bi bi-chat-dots-fill"
                  />

                  <StatTile
                    color="orange"
                    title="Unique Users Count"
                                       value={loading ? 'Loading...' : uniqueUsers}
                    iconClass="bi bi-person"
                    onClick={() =>
                      setDrilldown({
                        title: 'Unique Users',
                        type: 'UNIQUE_USERS',
                        rows: data?.users.unique_user_details || [],
                      })
                    }
                  />
                  <StatTile
                    color="purple"
                    title="Repeated Users Count"
                    value={loading ? 'Loading...' : repeatedUsers}
                    iconClass="bi bi-arrow-repeat"
                    onClick={() =>
                      setDrilldown({
                        title: 'Repeated Users',
                        type: 'REPEATED_USERS',
                        rows: data?.users.repeated_users_list || [],
                      })
                    }
                  />
                </div>
              </Col>
            </Row>
          </Container>

          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k as any)}
            className="mt-3"
          >
            <Tab eventKey="metrics" title="Metrics">
              <Row className="gx-3 gy-3 px-3 mt-1">

                <Col md={6}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header">Bot Conversation</div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : liveCallConnected + liveChatConnected + scheduleCallConnected + dropoffConversations === 0 ? (
                      <div className="chart-placeholder">No data to display</div>
                    ) : (
                      <div style={{ height: 280 }}>

                        <Bar
                          key={JSON.stringify(barDataLastUseCase)}
                          data={barDataLastUseCase}
                          options={{
                            ...barCommonOptions,
                            onClick: (_, elements, chart) =>
                              handleChartClick(
                                'BOT_CONVERSATION',
                                elements,
                                chart.data
                              ),
                          }}
                        />

                      </div>
                    )}
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header">Top 3 Use Cases</div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div style={{ height: 280 }}>
                        <Bar
                           key={JSON.stringify(barDataTop3Usecases)}
                          data={barDataTop3Usecases}
                          options={{
                            ...barWithLegendOptions,
                            onClick: (_, elements, chart) =>
                              handleChartClick(
                                'TOP_USE_CASES',
                                elements,
                                chart.data
                              ),
                          }}
                        />
                      </div>
                    )}
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header">Resolution Breakdown</div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : resolvedCount + partiallyResolvedCount + notResolvedCount === 0 ? (
                      <div className="chart-placeholder">No data to display</div>
                    ) : (
                      <div style={{ height: 280 }}>
                        <Pie
                        key={JSON.stringify(pieDataResolved)}
                          data={pieDataResolved}
                          options={{
                            ...pieOptions,
                            onClick: (event, _elements, chart) => {
                              const elements = chart.getElementsAtEventForMode(
                                event.native!,       //  use native DOM event
                                'nearest',
                                { intersect: true },
                                true
                              );

                              handleChartClick(
                                'RESOLVE_STATUS',
                                elements,
                                chart.data
                              );
                            },
                          }}
                        />
                        {/* <Pie
  data={pieDataResolved}
  options={{
    onClick: (_, elements) => {
      if (!elements.length) return;

      const index = elements[0].index;

      handleChartClick(
        index === 0 ? 'RESOLVED_BY_BOT' : 'NOT_RESOLVED_BY_BOT',
        elements
        
      );
    },
  }}
/> */}
                      </div>
                    )}
                  </Card>
                </Col>

                {/* ROW 2: Top 3 Usecases (Bar) md=8 */}


                {/* ROW 3: Monthly Growth (Line, md=8) + User Satisfaction (Doughnut, md=4) */}


                <Col md={4}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header">User Satisfaction</div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : Object.values(feedbackMap).every((v) => v === 0) ? (
                      <div className="chart-placeholder">No data to display</div>
                    ) : (
                      <div style={{ display: "flex", height: 280 }}>
                        {/* <div
                        style={{width: "40%",display: "flex",alignItems: "flex-start", justifyContent: "flex-start",padding: "10px"}}
                      >
                       <h5 style={{ margin: 0 }}>Average User Rating : </h5>
                      </div>*/}
                        <div
                          style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >

                          <Pie
                          key={JSON.stringify(doughnutDataUserSatisfaction)}
                            data={doughnutDataUserSatisfaction}
                            options={{
                              ...pieOptions,
                              onClick: (event, _elements, chart) => {
                                const elements = chart.getElementsAtEventForMode(
                                  event.native!,       //  use native DOM event
                                  'nearest',
                                  { intersect: true },
                                  true
                                );

                                handleChartClick(
                                  'USER_SATISFACTION',
                                  elements,
                                  chart.data
                                );
                              },
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </Card>
                </Col>

                {/* ROW 4: Top 5 Issues (Bar, full width md=12) */}
                {/* <Col md={12}>
                <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                  <div className="chart-card-header">Top 5 Call Drivers</div>
                  {loading ? (
                    <div className="chart-placeholder">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div style={{ height: 288, padding: "10px" }}>
                      <Bar data={barDataTop5Issues} options={barWithLegendOptions} />
                    </div>
                  )}
                </Card>
              </Col> */}
                <Col md={4}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header">Ticket Creation Breakdown</div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : direct_incident + kb_resolved_incident === 0 ? (
                      <div className="chart-placeholder">No data to display</div>
                    ) : (
                      <div
                        style={{ height: "280px", display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        {/* <Doughnut data={pieDataIncident} options={gaugeOptions} /> */}
                        <Doughnut
                        key={JSON.stringify(pieDataIncident)}
                          data={pieDataIncident}
                          options={{
                            ...gaugeOptions,
                            onClick: (event, _elements, chart) => {
                              const elements = chart.getElementsAtEventForMode(
                                event.native!,       //  use native DOM event
                                'nearest',
                                { intersect: true },
                                true
                              );

                              handleChartClick(
                                'TICKET_BREAKDOWN',
                                elements,
                                chart.data
                              );
                            },
                          }}
                        />
                      </div>
                    )}
                  </Card>
                </Col>


                <Col md={4}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header">Resolved Trend Graph</div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div style={{ height: 280 }}>
                        <Line key={JSON.stringify(lineChartDataResolved)} data={lineChartDataResolved} options={percentageLineOptions} />
                      </div>
                    )}
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header"> User Satisfaction Trend Graph </div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div style={{ height: 280 }}>
                        <Line key={JSON.stringify(lineChartDataUserSatisfaction)} data={lineChartDataUserSatisfaction} options={percentageLineOptions} />
                      </div>
                    )}
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="chart-card" style={{ minHeight: "300px", width: "100%", padding: "6px" }}>
                    <div className="chart-card-header">Unique Users Trend Graph</div>
                    {loading ? (
                      <div className="chart-placeholder">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div style={{ height: 280 }}>
                        <Line  key={JSON.stringify(lineChartData)} data={lineChartData} options={countLineOptions} />
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>
            </Tab>

            <Tab eventKey="reports" title="Reports">
              {renderReportsTab()}
            </Tab>
          </Tabs>

          <Container fluid>

          </Container>
        </div>
      </Container>
      {renderUsecaseModal()}
    </div>

  );
};

export default UowDashboard;